// extracted by mini-css-extract-plugin
export default {"f":"_0064caeae1","main":"_2b529ba792","btn":"c1cff49bc4","w":"_71ed8773c0","h":"aea9a10de4","lh25":"_9303824a92","wb":"_3e406bdaaf","b":"_47e72c9956","bx":"_128a34e4d7"};